import React from 'react'
import { formatNumberToCurrency } from 'app/utils/util-functions'

type LoanAmountSubtitleOptions = {
    existingAmount: number
    currency: string
    newAmount?: number
    showDifference?: boolean
}

export const renderLoanAmountSubtitle = ({
    existingAmount,
    currency,
    newAmount,
    showDifference = false,
}: LoanAmountSubtitleOptions): React.ReactNode => {
    const existingAmountFormatted = formatNumberToCurrency(existingAmount, currency)

    const existingLine = (
        <div>
            <span className="form-subtitle-label">Existing Loan Amount: </span>
            <span className="form-subtitle-amount">{existingAmountFormatted}</span>
        </div>
    )

    if (!showDifference || !newAmount) {
        return <div className="form-subtitle-container">{existingLine}</div>
    }

    const difference = newAmount - existingAmount
    const label = difference > 0 ? 'Increase Amount' : 'Paydown Amount'
    const differenceAmountFormatted = formatNumberToCurrency(Math.abs(difference), currency)

    return (
        <div className="form-subtitle-container">
            {existingLine}
            <div>
                <span className="form-subtitle-label">{label}: </span>
                <span className="form-subtitle-amount">{differenceAmountFormatted}</span>
            </div>
        </div>
    )
}
